<script>
    import * as d3 from "d3";
    import * as druid from "@saehrimnir/druidjs";

    import Eval from "./Eval.svelte";
    import Scatterplot from "./Scatterplot.svelte";
    import Compare from "./Compare.svelte";
    import SmallComp from "./SmallComp.svelte";
    import SmallCompAlt from "./SmallCompAlt.svelte";
    import SuppComp from "./SuppComp.svelte";
    import SuppEval from "./SuppEval.svelte";
    import SuppEvalAlt from "./SuppEvalAlt.svelte";
    import ScatterPlotAlt from "./ScatterPlotAlt.svelte";


    let w = 15;
    let h = 15;
    let margin = 50;

    async function load_data(path) {
        let data = await d3.json(path)
        //data.PCA = data.PCA.map(rows => rows.filter((d, i) => i < 32));
        for (const key of Object.keys(data)) {
            data[key] = data[key].map(rows => rows.filter((d, i) => i >= 1 && i < 32))
        }
        data = {
            "PCA": data.PCA || [],//.map(rows => rows.filter((d, i) => i >= 1 && i < 32)),
            "LLE": data.LLE || [],//.map(rows => rows.filter((d, i) => i >= 1 && i < 32)),
            "TSNE": data.TSNE || [],//.map(rows => rows.filter((d, i) => i >= 1 && i < 32)),
            "MDS": data.MDS || [],//.map(rows => rows.filter((d, i) => i >= 1 && i < 32)),
            "ISOMAP": data.ISOMAP || [],//.map(rows => rows.filter((d, i) => i >= 1 && i < 32)),
            "UMAP": data.UMAP || [],//.map(rows => rows.filter((d, i) => i >= 1 && i < 32)),
        };
        return data
    }

    async function load_data2() {
        try {
            return [await load_data("eval6_8x14.json"), await load_data("eval_sklearn.json"), await load_data("eval_js.json"), await load_data("eval_supp.json")]
        } catch(e) {
            console.warn(e)
        }
    }

    async function load_data_supp(path, lib) {
        let D = await d3.json(path);
        let data = Object.keys(D).map((key) => {
            let rows = D[key].map((row, i) => {
                return row.filter((d, i) => i >= 1 && i < 32 && d != 0)
            });
            rows.DR = key;
            rows.LIB = lib;
            return rows;
        })
        return data//.filter(d => d.LIB != "druid");
    }

    async function load_supp(full=true) {
        let D = []
        let list = full ? [["eval6_8x14.json", "druid"], ["eval_sklearn.json", "sklearn"], ["eval_js.json", "js"], ["eval_supp.json", "druid"]] : [["eval6_8x14.json", "druid"], ["eval_supp.json", "druid"]]
        for (const [path, lib] of list) {
            D.push(await load_data_supp(path, lib))
        }
        return D.flat()
            .sort((a, b) => d3.ascending(a.DR, b.DR))
            .sort((a, b) => d3.ascending(a.LIB, b.LIB))
    }

    async function load_small(t) {
        let [data, dataSK, dataJS] = await load_data2();
        let Ns = d3.range(Math.max(...[Object.values(data), Object.values(dataSK), Object.values(dataJS)].flat().flat().map(d => d.filter(d => d != 0).length)))
            .map(n => Math.floor(16 + 2 ** (n/2 + 1)));
        let Ds = d3.range([Object.values(data)[0].length]).map(d => Math.floor(2 * 5**((d+1)/2)));
        let D = d3.zip(Object.values(data), Object.values(dataSK), Object.values(dataJS))
            .map(([dr, sk, js], i) => {
                if (t == 1) {
                    dr = d3.range(27)
                        .map(j => dr[j] || [])
                        .map(row => row.filter(d => d != 0)
                        .map(d => d3.extent(d.dur, d => d[2] - d[0]).map(d => [d, "dr"])));
                    sk = d3.range(27).map(j => sk[j] || []).map(row => row.filter(d => d != 0).map(d => d3.extent(d.dur, d => d[2] - d[0]).map(d => [d, "sk"])));
                    js = d3.range(27).map(j => js[j] || []).map(row => row.filter(d => d != 0).map(d => d3.extent(d.dur, d => d[2] - d[0]).map(d => [d, "js"])));
                    return [dr, sk, js]
                } else {
                    dr = d3.range(27).map(j => dr[j] || []).map(row => row.filter(d => d != 0).map(d => [d3.mean(d.dur, d => d[2] - d[0]), "druid"]));
                    sk = d3.range(27).map(j => sk[j] || []).map(row => row.filter(d => d != 0).map(d => [d3.mean(d.dur, d => d[2] - d[0]), "sklearn"]));
                    js = d3.range(27).map(j => js[j] || []).map(row => row.filter(d => d != 0).map(d => [d3.mean(d.dur, d => d[2] - d[0]), "js"]));
                    return [dr, sk, js]
                }
            })
            .map(([dr, sk, js], i) => {
                //console.log(dr, sk, js)
                return Ds.map((d, j) => {
                    return Ns.slice(0, 31).map((n, k) => {
                        return {
                            d: j,
                            n: k,
                            winner: winner(dr[j][k], sk[j][k], js[j][k], t),
                            m: Object.keys(data)[i],
                        }
                    })
                })
            })
            
        D.keys = Object.keys(data);
        return D;
    }

    function winner(dr, sk, js, t) {
        if (t == 1) {
            let values = [dr, sk, js].filter(d => d)
            if (values.length == 0) return "none"
            let [f, s, ...rest] = values.flat()
                /* .filter(d => ) */
                .sort((a, b) => d3.ascending(a[0] || null, b[0] || null));
            
            switch (f[1] + s[1]) {
                case "sksk": return "sklearn";
                case "skdr":
                case "drsk":
                    return "dr_sk";
                case "drdr": return "druid";
                case "drjs":
                case "jsdr":
                    return "dr_js";
                case "jsjs": return "js";
                case "skjs":
                case "jssk":
                    return "sk_js";
                default: return "both";
            }
        } else {
            let T = [dr, sk, js]
                .filter(d => d)
                .sort((a, b) => d3.ascending(a[0], b[0]))
            if (T.length == 0) return "none"
            if (T[0][1] == "druid") {
                return "druid"
            }
            if (T.slice(1).findIndex(d => d[1] == "druid") >= 0) {
                let druid_time = T.slice(1).find(d => d[1] == "druid")[0]
                let p = druid_time / T[0][0] ;
                let suffix = ""
                if (p < 2) {
                    suffix = "2";
                } else if (p < 5) {
                    suffix = "5";
                } else if (p < 10) {
                    suffix = "10";
                } else {
                    suffix = "x";
                }
                return T[0][1] + suffix
            }
            return T[0][1];
        }
        
    }
    
    /* function win(l, r) {
        if (l == undefined && r != undefined) return "r";
        if (l != undefined && r == undefined) return "l";
        if (l == undefined && r == undefined) return "none";
        if (r[0] <= l[0] && r[1] <= l[0]) return "r";
        if (l[0] <= r[0] && l[1] <= r[0]) return "l";
        return "draw"
    } */

    async function comp_dr(X, DR) {
        let dims = ["bill_depth_mm", "bill_length_mm", "flipper_length_mm", "body_mass_g"]
        let maxes = dims.map(key => d3.max(X, d => +d[key]))
        let classes = X.map(d => d.species);
        let values = X.map(d => dims.map((key, i) => +d[key] / maxes[i]))
        const V = druid.Matrix.from(values)
        let Y = comp(V, DR, classes);
        return Y
    }

    function comp(V, DR, classes) {
        return new Promise(res => {
            switch (DR) {
                case "UMAP":
                    (new druid.UMAP(V)).transform_async().then(Y => {
                        res(Y.to2dArray)
                    });
                    break;
                case "TSNE":
                    (new druid.TSNE(V)).transform_async().then(Y => res(Y.to2dArray));
                    break;
                case "LDA":
                    (new druid.LDA(V, V.to2dArray.map(d => 0))).transform_async().then(Y => res(Y.to2dArray));
                    break;
                case "ISOMAP":
                    new druid.ISOMAP(V).transform_async().then(Y => res(Y.to2dArray));
                    break;
                case "MDS":
                    new druid.MDS(V).transform_async().then(Y => res(Y.to2dArray));
                    break;
                case "PCA":
                    new druid.PCA(V).transform_async().then(Y => res(Y.to2dArray));
                    break;
                case "MDS":
                    new druid.MDS(V).transform_async().then(Y => res(Y.to2dArray));
                    break;
                case "LLE":
                    new druid.LLE(V, 34).transform_async().then(Y => res(Y.to2dArray));
                    break;
                case "LTSA":
                    new druid.LTSA(V ,34).transform_async().then(Y => res(Y.to2dArray));
                    break;
                case "TriMap":
                    new druid.TriMap(V, 100000, 4).transform_async().then(Y => res(Y.to2dArray));
                    break;
                default:
                    new druid.FASTMAP(V).transform_async().then(Y => res(Y.to2dArray));
                    break;
            }
        })
    }

    let R;
    let computing = false;
    let t;
    let interval;
    let start = performance.now();

    function wait(t) {
        return new Promise(res => {
            window.setTimeout(res, t);
        })
    }


    async function selected(e) {
        if (computing) return;
        try {
            R = null;
            const {d, n, dr} = e.detail;
            let computing = true;

            let X = new druid.Matrix(n, d, () => Math.random());
            await wait(10)
            start = performance.now()
            /* let ifunc = (start) => {
                
                console.log(start, t)
                t = Math.round(performance.now() - start);
            }
            interval = window.setInterval(ifunc, 10, start) */
            comp(X, dr).then(async Y => {
                t = d3.format(".2f")(performance.now() - start);

                await wait(10)
                R = {Y: Y, DR: dr, d: d, n: n};
                window.clearInterval(interval);
                computing = false;
                
            });

        } catch(e) {
            window.clearInterval(interval)
        } finally {
        }
    }

</script>

<main>
    <aside on:mouseenter={() => {R=null; t=undefined}}>
        <ScatterPlotAlt Y={R ? R.Y : []} DR={R?.DR} d={R?.d} n={R?.n}></ScatterPlotAlt>
        {#if t != undefined}<p font-family="Courier Prime"><span>Runtime</span> {t}ms</p>{/if}
        
    </aside>
    <section>
        {#await load_supp(false)}
            <p></p>
        {:then D}
            <SuppEvalAlt 
                D={D}
                on:select={selected} computing={computing}>
            </SuppEvalAlt>
        {/await}
        <!-- {#await load_data("eval6_8x14.json")}
            <p>eval</p>
        {:then data}
            <Eval 
                data={data}
                w={w}
                h={h}
                margin={margin}
            
            ></Eval>
        {/await} -->
        <!-- {#await load_supp()}
            <p>wait for it...</p>
        {:then D}
            <SuppComp D={D}>
            </SuppComp>
        {/await} -->
        <!-- {#await load_supp()}
            <p>wait for it...</p>
        {:then D}
            <SuppEval D={D}>
            </SuppEval>
        {/await} -->
        
        <!-- {#await load_small(1)}
            <p>small comp</p>
        {:then D}
            <SmallComp
                data={D}>
            </SmallComp>
        {/await} -->
        <!-- {#await load_small(0)}
            <p>small comp</p>
        {:then D}
            <SmallCompAlt
                data={D}>
            </SmallCompAlt>
        {/await} -->
        <!-- {#await load_data2()}
            <p>compare</p>
        {:then D}

            <Compare data={D[0]} dataSK={D[1]} dataJS={D[2]}></Compare>
        {/await} -->
        
    </section>
    <section>
        <!-- {#await d3.csv("penguins.csv")}
            wait
        {:then data}
            {#each ["FASTMAP", "ISOMAP", "LDA", "LLE", "LTSA", "MDS", "PCA", "TSNE", "TriMap", "UMAP"] as DR}
                {#await comp_dr(data, DR)}
                    <p>compute {DR}</p>
                {:then Y}
                    <Scatterplot X={data} DR={DR} Y={Y}></Scatterplot>
                {/await}
            {/each}
        {/await} -->
    </section>
</main>

<style>
	:global(svg) {
        background-color: #f0f0f0;
    }

    aside {
        position: fixed;
        top: 1rem;
        right: 1rem;

    }

    section { 
        margin-bottom: 100vh;
    }
</style>